export default {"src":"/_next/static/media/blu-arrow-grad.15ac6c64.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};